import type { Step } from '@/types'

/** Objective-specific steps: Focus & Cognition (foco_cognicao) */
export const focusCognitionSteps: Step[] = []
